import { React, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ref, deleteObject } from "firebase/storage";
import { db, storage } from "./Firebase.js";
import { doc, deleteDoc } from "firebase/firestore";
import saveAs from "file-saver";
import "./expand.css";
import "./home.css";

function Expand() {
  let navigate = useNavigate();
  const [deleteMsg,setDeleteMsg] = useState("Delete");
  const location = useLocation();

  const save = () => {
    saveAs(location.state.imageURL, "download.png");
  };

  const deleteimage = () => {
    setDeleteMsg("Deleting");
    const desertRef = ref(
      storage,
      `${location.state.email}/${location.state.filename}`
    );

    // Delete the file
    deleteObject(desertRef)
      .then(async () => {
        await deleteDoc(doc(db, location.state.email, location.state.filename));
        navigate("/");
        setDeleteMsg("Delete");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const goBack = () => {
    navigate("/", { state: { email: location.state.email } });
  };

  return (
    <div className="rightdiv">
      <div className="details">
        <div className="detailsInner">
          <div className="datediv">
            <span className="date">Date: {location.state.date1}</span>
          </div>
          <div className="filenamediv"></div>
        </div>
        <div className="download">
          <svg onClick={save}
            className="downloadicon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
          >
            <path
              d="M144 480C64.47 480 0 415.5 0 336C0 273.2 40.17 219.8 96.2 200.1C96.07 197.4 96 194.7 96 192C96 103.6 167.6 32 256 32C315.3 32 367 64.25 394.7 112.2C409.9 101.1 428.3 96 448 96C501 96 544 138.1 544 192C544 204.2 541.7 215.8 537.6 226.6C596 238.4 640 290.1 640 352C640 422.7 582.7 480 512 480H144zM303 392.1C312.4 402.3 327.6 402.3 336.1 392.1L416.1 312.1C426.3 303.6 426.3 288.4 416.1 279C407.6 269.7 392.4 269.7 383 279L344 318.1V184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184V318.1L256.1 279C247.6 269.7 232.4 269.7 223 279C213.7 288.4 213.7 303.6 223 312.1L303 392.1z"
            />
          </svg>
          <button className="delete" onClick={deleteimage}>
            {deleteMsg}
          </button>
        </div>
      </div>
      <div className="bigimage">
        <img
          className="Img"
          src={location.state.imageURL}
          alt="Not found"
          onClick={goBack}
        />
      </div>
    </div>
  );
}

export default Expand;
